import { useState } from "react";
import styles from "./CustomDatePicker.module.css";
import dayjs from "dayjs";

const CustomDatePicker = ({ preSelectedDate, onDateSelect }) => {
  const [currentMonth, setCurrentMonth] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState(null);

  const startOfMonth = currentMonth.startOf("month");
  const daysInMonth = currentMonth.daysInMonth();

  const today = dayjs().startOf("day");

  const generateCalendar = () => {
    const days = [];
    // Convert Sunday (0) to 7, so Monday becomes 1, Tuesday 2, ..., Sunday 7
    let startDay = startOfMonth.day();
    startDay = startDay === 0 ? 7 : startDay;
    // Adjust to make Monday = 0
    const offset = startDay - 1;

    // Add empty cells for days before the 1st
    for (let i = 0; i < offset; i++) {
      days.push(null);
    }

    // Add all days of the month
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(startOfMonth.date(i));
    }

    return days;
  };

  const handleDateSelect = (date) => {
    if (!date || date.isBefore(today)) return;
    setSelectedDate(date);
    onDateSelect && onDateSelect(date);
  };

  const isSameDay = (a, b) => a && b && a.isSame(b, "day");

  return (
    <div className={styles.calendarWrapper}>
      <div className={styles.header}>
        <button
          onClick={() => setCurrentMonth(currentMonth.subtract(1, "month"))}
          className={styles.navBtn}
        >
          ◀
        </button>
        <span className={styles.monthLabel}>
          {currentMonth.format("MMMM YYYY")}
        </span>
        <button
          onClick={() => setCurrentMonth(currentMonth.add(1, "month"))}
          className={styles.navBtn}
        >
          ▶
        </button>
      </div>

      <div className={styles.weekRow}>
        {["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((day) => (
          <div key={day} className={styles.weekDay}>
            {day}
          </div>
        ))}
      </div>

      <div className={styles.dateGrid}>
        {generateCalendar().map((date, idx) => {
          if (!date) {
            return <div key={idx} className={styles.dateCell}></div>;
          }
          const isDisabled = date.isBefore(today);
          const isSelected = isSameDay(date, selectedDate ?? preSelectedDate);
          return (
            <div
              key={idx}
              className={`${styles.dateCell} ${
                isSelected ? styles.selected : ""
              } ${isDisabled ? styles.disabled : ""}`}
              onClick={() => handleDateSelect(date)}
            >
              {date.date()}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CustomDatePicker;
